// extracted by mini-css-extract-plugin
export default {"field":"SearchField_field__W9E7f","icon":"SearchField_icon__lF2o5","clear":"SearchField_clear__1gxL-","input":"SearchField_input__jsEct"};